module.exports = __webpack_public_path__ + "asset/image-ic_category_35-48eb02a3fc1e4bd6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_35.svg
// module id = WITs
// module chunks = 0